import type { PublicInvoice, PublicLanguage } from '@/entities/publicReport';

import type { PublicCopy } from '../copy';
import { formatAmount } from '../format';
import { ActionLink } from './ActionLink';
import { PublicBlock } from './PublicBlock';

export interface InvoiceBlockProps {
    invoice: PublicInvoice;
    language: PublicLanguage;
    copy: PublicCopy;
}

export function InvoiceBlock({ invoice, language, copy }: InvoiceBlockProps) {
    return (
        <PublicBlock className="flex flex-wrap items-center justify-between gap-[14px] py-[22px]">
            <div className="min-w-0">
                <div className="text-[14px] leading-[1.35] font-medium text-[var(--text-primary)]">
                    {`${copy.invoiceLabel} ${invoice.number} · ${formatAmount(invoice.amount, language, { cents: true })}`}
                </div>
                {invoice.paymentNote ? (
                    <div
                        className={`mt-[3px] text-[12px] leading-[1.4] ${
                            invoice.status === 'overdue'
                                ? 'text-[var(--danger-text)]'
                                : 'text-[var(--accent-dark)]'
                        }`}
                    >
                        {invoice.paymentNote}
                    </div>
                ) : null}
            </div>

            {invoice.pdfUrl ? (
                <ActionLink href={invoice.pdfUrl} variant="outline" size="md">
                    {copy.invoiceDownload}
                </ActionLink>
            ) : null}
        </PublicBlock>
    );
}
